import React from "react";
import { formatMonthYearLong } from "../../../utils/dateUtils";
import { Icons } from "../../shared/Icons";

interface MonthPeriodPickerProps {
  month: number;
  year: number;
  onChange: (month: number, year: number) => void;
  disabled?: boolean;
  className?: string;
}

export const MonthPeriodPicker: React.FC<MonthPeriodPickerProps> = ({
  month,
  year,
  onChange,
  disabled = false,
  className = "",
}) => {
  const monthValue = `${year}-${String(month).padStart(2, "0")}`;

  const goPrevMonth = () => {
    if (disabled) return;
    if (month <= 1) {
      onChange(12, year - 1);
    } else {
      onChange(month - 1, year);
    }
  };

  const goNextMonth = () => {
    if (disabled) return;
    if (month >= 12) {
      onChange(1, year + 1);
    } else {
      onChange(month + 1, year);
    }
  };

  const handleMonthInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!value) return;
    const [y, m] = value.split("-").map((part) => parseInt(part, 10));
    if (!isNaN(y) && !isNaN(m) && m >= 1 && m <= 12) {
      onChange(m, y);
    }
  };

  return (
    <div
      className={`flex items-center gap-1.5 sm:gap-2 ${className}`.trim()}
    >
      <button
        type="button"
        onClick={goPrevMonth}
        disabled={disabled}
        className="flex-shrink-0 p-2 rounded-lg border border-gray-200 dark:border-slate-600 text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Mês anterior"
      >
        <Icons.ChevronLeft sx={{ fontSize: 22 }} />
      </button>

      <label className="relative flex-1 min-w-[10rem] sm:min-w-[12rem]">
        <span className="sr-only">Selecionar mês</span>
        <input
          type="month"
          value={monthValue}
          onChange={handleMonthInput}
          disabled={disabled}
          className="w-full px-3 py-2 text-sm sm:text-base font-semibold text-gray-900 dark:text-white text-center border border-gray-200 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700 focus:ring-2 focus:ring-sky-500 focus:border-sky-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
          aria-label={`Período: ${formatMonthYearLong(month, year)}`}
        />
      </label>

      <button
        type="button"
        onClick={goNextMonth}
        disabled={disabled}
        className="flex-shrink-0 p-2 rounded-lg border border-gray-200 dark:border-slate-600 text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Próximo mês"
      >
        <Icons.ChevronRight sx={{ fontSize: 22 }} />
      </button>
    </div>
  );
};
